function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { ItemMemberLevel } from "sprout-graphql";
import { Card, CardLink, CardContent } from "@sprout/client-components/dist/Card";
import Avatar from "@sprout/client-components/dist/Avatar";
import { Flex, Box, Text } from "sprout-ui-primitives";
import getFullName from "@sprout/client-lib/dist/getFullName";
import { capitalize } from "lodash";
import { useNavigationListItem } from "@sprout/list-navigation";
import { convertTopicMemberToItemMemberLevel } from "@sprout/client-lib";
import TopicMembersPageTopicMemberMenu from "./TopicMembersPage_TopicMember_Menu";
const TopicMembersPageTopicMember = (props)=>{
    const { topicMember , topic , currentUserMemberLevel , isPartOfPaidTeam  } = props;
    const { user  } = topicMember;
    const isTopicPublic = topic.public;
    const topicId = topic.id;
    const { navProps , helpers: navigationItemHelpers  } = useNavigationListItem(String(topicMember.nodeId), useMemo(()=>({
            object: topicMember
        }), [
        topicMember
    ]));
    // Technically this will never happen because TopicMembersPage guards this for us.
    if (!user) return null;
    const fullName = getFullName(user);
    const topicMemberMemberLevel = convertTopicMemberToItemMemberLevel(topicMember);
    return /*#__PURE__*/ _jsxs(Card, _objectSpread({}, navProps, {
        style: navigationItemHelpers.isActive ? {
            backgroundColor: "rgba(25, 118, 210, 0.04)"
        } : undefined,
        children: [
            /*#__PURE__*/ _jsx(CardLink, {
                to: `/${user.username}`
            }),
            /*#__PURE__*/ _jsxs(CardContent, {
                as: Flex,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        flex: "none",
                        mr: "16px",
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            user: user,
                            size: 48,
                            navigable: true
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        minWidth: "0",
                        flex: "auto",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                truncate: true,
                                fontSize: "18px",
                                fontWeight: "bold",
                                children: user.username
                            }),
                            fullName.length !== 0 && /*#__PURE__*/ _jsx(Text, {
                                truncate: true,
                                fontSize: 1,
                                color: "black.60",
                                mt: "2px",
                                children: fullName
                            })
                        ]
                    }),
                    topicMemberMemberLevel && topicMemberMemberLevel !== ItemMemberLevel.Contributor && /*#__PURE__*/ _jsx(Text, {
                        fontSize: "15px",
                        color: "black.60",
                        mr: "4px",
                        children: capitalize(topicMemberMemberLevel)
                    }),
                    /*#__PURE__*/ _jsx(TopicMembersPageTopicMemberMenu, {
                        currentUserMemberLevel: currentUserMemberLevel,
                        topicMember: topicMember,
                        topicId: topicId,
                        isTopicPublic: isTopicPublic,
                        isPartOfPaidTeam: isPartOfPaidTeam
                    })
                ]
            })
        ]
    }));
};
export default TopicMembersPageTopicMember;
